import type { Company } from "../../models/company";
import { DataTable, type DataTableProps } from "../datatable/DataTable";

type CompaniesTableProps = {
  companies: Company[];
} & Required<
  Pick<DataTableProps<Company>, "onEdit" | "onDelete" | "onSortStatusChange" | "sortStatus" | "pagination" | "onPageChange" | "fetching">
>;

export function CompaniesTable({ companies, ...props }: CompaniesTableProps) {
  return (
    <DataTable
      columns={[
        {
          accessor: "name",
          title: "Name",
          sortable: true,
        },
      ]}
      records={companies}
      {...props}
    />
  );
}
